angular.module('impactx.controlstructure').controller('AccountingHelperCtrl', AccountingHelperCtrl);

AccountingHelperCtrl.$inject = ['dataGen', '$mdDialog', 'params', 'current', 'themeFactory', '$locale'];

function AccountingHelperCtrl(dataGen, $mdDialog, params, current, themeFactory, $locale) {
    var ctrl = this;
    ctrl.controls = [];
    ctrl.controlTitle = "";
    ctrl.trns = {};
    ctrl.total = 0;
    ctrl.isInvalid = true;
    ctrl.fractionSize = 2;
    ctrl.theme = themeFactory.getTheme();

    var initial = JSON.parse(JSON.stringify(current));


    ctrl.getData = function () {
        var paramObj = {
            ctrlString: params.ctrlString,
            bksId: params.bksId || 0,
            bkiId: params.bkiId || 0
        };
        dataGen.getData({}, paramObj, "/basket/controlhelper").then(function (data) {
            if (data && data.data) {
                ctrl.controls = data.data.controls;
                ctrl.controlTitle = data.data.controlTitle;
                ctrl.trns = data.trns;
                ctrl.hasAvailable = ctrl.controls && ctrl.controls.length > 0;
                ctrl.fractionSize = data.data.factorFractionSize;
                if (initial && initial.length > 0) {
                    angular.forEach(initial, function (item) {
                        var filtered = ctrl.controls.filter(function (entry) {
                            return item.id === entry.id;
                        });
                        if (filtered.length > 0 && item.factor) {
                            filtered[0].factor = item.factor;
                        }
                    });
                }
                ctrl.checkFactors();
            }
        });
    };

    ctrl.checkFactors = function () {
        if (ctrl.controls && ctrl.controls.length > 0) {
            ctrl.total = 0;
            for (var i = 0; i < ctrl.controls.length; i++) {
                ctrl.total += ctrl.controls[i].factor * 100;
            }
            ctrl.isInvalid = ctrl.total !== 100;
        }
        else {
            ctrl.isInvalid = true;
        }
    };

    ctrl.apply = function () {
        if (!ctrl.isInvalid) {
            var result = ctrl.controls.filter(function (entry) {
                return entry && !!entry.factor;
            });
            $mdDialog.hide(result);
        }
    };

    ctrl.abort = function () {
        $mdDialog.cancel()
    };

    ctrl.reset = function () {
        angular.forEach(ctrl.controls, function (entry) {
            entry.factor = null;
        });
        ctrl.isInvalid = true;
        ctrl.total = 0;
    };

    ctrl.formattedTotal = function() {
        var formats = $locale.NUMBER_FORMATS;
        var fractionSize = ctrl.fractionSize || formats.PATTERNS[1].maxFrac;
        var pattern = {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 3,
                "minFrac": 0,
                "negPre": "-",
                "negSuf": "",
                "posPre": "",
                "posSuf": "%"
            };
        return formatNumber(ctrl.total, pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
    };

    ctrl.getData();
}